
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveaway-status",
      function () {
        return require("private-next-pages/giveaway-status.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveaway-status"])
      });
    }
  